'use client';
import { useRouter } from "next/navigation"
import Header from "@/components/sections/Header"
import Footer from "@/components/Footer"
import { ReactNode } from "react"

type HeaderFooterLayoutProps = {
  children: ReactNode;
  breadcrumbs?: boolean;
};

export default function HeaderFooterLayout({ children, breadcrumbs = true , layoutData}: HeaderFooterLayoutProps & any) {


  const router = useRouter();

  const logotypeClick = () => router.push('/');

  return <>
    <Header {...layoutData?.header} />
    <div className="">
      { children }
      <Footer onClickLogo={logotypeClick} data={layoutData?.footer}/>
    </div>
  </>
}